import React from "react"
import clsx from "clsx"

import { SyncJobInfo } from "@framework/types/content-manager"
import Icon from "@components/ui/Icon/Icon"
import Text from "@components/ui/Typography/Text"
import Button from "@components/ui/Button/Button"

import styles from "./SyncInfo.module.sass"

export type SynInfoItemProps = {
  job: SyncJobInfo
  handleHideJob: (jobId: string) => void
}

const SynInfoItem: React.FC<SynInfoItemProps> = ({ job, handleHideJob }) => {
  const isError = job.status === "error"
  const isWarning = job.status === "warning"

  return (
    <div
      className={clsx(styles.root, {
        [styles.error]: isError,
        [styles.warning]: isWarning,
      })}
      key={job.id + (job.error || job.syncWarning || "")}
    >
      <div>
        <div className={styles.info}>
          <div
            className={clsx(styles.iconWrapper, {
              [styles.warningIconWrapper]: isWarning,
            })}
          >
            <Icon
              name={isError ? "info" : isWarning ? "info" : "upload-cloud"}
              className={styles.infoIcon}
            />
          </div>

          <div className={styles.headings}>
            {isError ? (
              <>
                <Text variant="h3">
                  Connector {job?.name} - {job?.type} has reported an error
                </Text>
                <Text variant="body2" color="redColor">
                  {job.error || "Unknown error occurred during synchronization"}
                </Text>
              </>
            ) : isWarning ? (
              <>
                <Text variant="h3">
                  Connector {job?.name} - {job?.type} sync completed with warnings
                </Text>
                <Text variant="body2" className={styles.warningText}>
                  {job.syncWarning ||
                    "Some SharePoint items were skipped, but most content was indexed."}
                </Text>
              </>
            ) : (
              <>
                <Text variant="h3">
                  Syncing Content from {job?.name} {job?.type}
                </Text>
                <Text variant="body2">
                  We are currently syncing your Contents from {job?.name}{" "}
                  {job?.type} account. This process ensures easy retrieval and
                  AI-powered analysis of your content.
                </Text>
              </>
            )}
          </div>
        </div>
        {!!job?.statusInfo?.length && (
          <div className={styles.statusInfos}>
            {job.statusInfo?.map((item) => (
              <span key={`${item.key}-${item.value}`}>
                <Text color="text50Color">{item.key} :</Text>
                <Text color="greenColor">{item.value}</Text>
              </span>
            ))}
          </div>
        )}
      </div>
      <Button variant="text" size="tiny" onClick={() => handleHideJob(job?.id)}>
        <Icon name="cross" />
      </Button>
    </div>
  )
}

export default SynInfoItem
